/**
 * Re-scan a DOM subtree for Swym Wishlist Plus `[data-swaction]` buttons after
 * dynamic HTML updates. See https://developers.getswym.com/docs/swym-powered-buttons
 *
 * @param {Element} [scope=document.body] - Container that includes Swym buttons
 */
export default function reinitSwymActionButtons(scope = document.body) {
  if (!scope) {
    return;
  }

  const run = () => {
    const swat = window._swat;
    if (!swat || typeof swat.initializeActionButtons !== 'function') {
      return;
    }

    let containerSelector = 'body';
    let cleanup;

    if (scope !== document.body && scope !== document.documentElement) {
      if (scope.id) {
        containerSelector = `#${CSS.escape(scope.id)}`;
      } else {
        const token = `swym-reinit-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
        scope.setAttribute('data-swym-reinit-scope', token);
        containerSelector = `[data-swym-reinit-scope="${CSS.escape(token)}"]`;
        cleanup = () => scope.removeAttribute('data-swym-reinit-scope');
      }
    }

    try {
      swat.initializeActionButtons(containerSelector);
    } catch (error) {
      // Swym throws when its own API is down; don't let that abort our product init.
      console.warn('Swym initializeActionButtons failed', error);
    } finally {
      cleanup?.();
    }
  };

  if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
    run();
  } else {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(run);
  }
}
